import axios from 'axios';
import Config from '../config/env';

export const _API = Config.baseurl

const getHeaders = (headers = {}) => ({
    headers: {
        ...headers,
        type: "admin"
    }
})
axios.defaults.withCredentials = true;

export default
    {
        get: function (endpoint) {
            return axios.get(`${_API + endpoint}`, getHeaders());
        },
        post: function (endpoint, params = {}) {
            return axios.post(`${_API + endpoint}`, params, getHeaders());
        },
        put: function (endpoint, params = {}) {
            return axios.put(`${_API + endpoint}`, params, getHeaders());
        },
        delete: function (endpoint) {
            return axios.delete(`${_API + endpoint}`, getHeaders());
        },
        patch: function (endpoint, params = {}) {
            return axios.patch(`${_API + endpoint}`, params, getHeaders());
        },
        uploadFormData: function (endpoint, formData) {
            return axios.post(`${_API + endpoint}`, formData, getHeaders({ 'Content-Type': 'multipart/form-data' }));
        },
        updateFormData: function (endpoint, formData) {
            return axios.post(`${_API + endpoint}`, formData, getHeaders({ 'Content-Type': 'multipart/form-data' }));
        },
        downloadFile: function (file) {
            return axios.get(`${_API}/api/download/${file}`)
        },
        downloadSignedForm: function (id, form, filePosition = null, isMultipleFile = false) {
            let newQuery = ''
            if (isMultipleFile) {
                newQuery = '?multiple=1'
            } else {
                newQuery = `${filePosition != null ? `/${filePosition}` : ''}`
            }
            return axios({ method: 'get', url: `${_API}/api/forms/${form}/${id}${newQuery}`, headers: getHeaders().headers, responseType: 'blob' });
        },
        getMMPProofFile: function (mmpProof) {
            return axios({ method: 'get', url: `${_API}/api/forms/mmp-proof-file/${mmpProof}`, headers: getHeaders().headers, responseType: 'blob' });
        },
        downloadReport: function (endpoint) {
            return axios({ method: 'get', url: `${_API}${endpoint}`, headers: getHeaders().headers, responseType: 'blob' });
        }
    }
